import { create } from 'zustand';

interface UserDataState {
  isPrivilegeUser: boolean;
  setIsPrivilegeUser: (isPrivilegeUser: boolean) => void;
}

const useUserDataStore = create<UserDataState>((set) => ({
  isPrivilegeUser: false,
  setIsPrivilegeUser: (isPrivilegeUser:boolean) => set({ isPrivilegeUser }),
}));

export default useUserDataStore;
